<template>
  <nav class="navbar navbar-expand-lg navbar-dark">
    <button class="navbar-toggler toggle--leaderboard collapsed" type="button" data-toggle="collapse" data-target="#leaderboards" aria-controls="leaderboards" aria-expanded="false" aria-label="Toggle navigation">
      {{selectedBoardText[boardType]}} <span class="fas fa-caret-down" />
    </button>

    <!-- todo add longest winning streak and longest losing streak for each player? -->

    <div class="collapse navbar-collapse navbar--leaderboard" id="leaderboards">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item clickable" @click="boardType = 'score'"><span class="nav-link">Highest Scores</span></li>
        <li class="nav-item clickable" @click="boardType = 'modalscore'"><span class="nav-link">Modal Scores</span></li>
        <li class="nav-item clickable" @click="boardType = 'medianweeks'"><span class="nav-link">Weekly Median</span></li>
        <li class="nav-item clickable" @click="boardType = 'weeklyaverage'"><span class="nav-link">Weekly Average</span></li>
        <li class="nav-item clickable" @click="boardType = 'medianyears'"><span class="nav-link">Yearly Median</span></li>
        <li class="nav-item clickable" @click="boardType = 'yearlyaverage'"><span class="nav-link">Yearly Average</span></li>
        <li class="nav-item clickable" @click="boardType = 'highestlow'"><span class="nav-link">Highest Low Score</span></li>
        <li class="nav-item clickable" @click="boardType = 'lowesthigh'"><span class="nav-link">Lowest High Score</span></li>
        <li class="nav-item clickable" @click="boardType = 'victorymargins'"><span class="nav-link">Victory Margins</span></li>
        <li class="nav-item clickable" @click="boardType = 'weeklymargins'"><span class="nav-link">Weekly Margins</span></li>
        <li class="nav-item clickable" @click="boardType = 'luckywinners'"><span class="nav-link">Lucky Winners</span></li>
        <li class="nav-item clickable" @click="boardType = 'unluckylosers'"><span class="nav-link">Unlucky Losers</span></li>
        <li class="nav-item clickable" @click="boardType = 'highestloser'"><span class="nav-link">Highest Losers</span></li>
        <li class="nav-item clickable" @click="boardType = 'lowestwinner'"><span class="nav-link">Lowest Winner</span></li>
      </ul>
    </div>
  </nav>
  <div v-if="matchups.length === 0">No teams loaded.</div>
  <div v-else-if="boardType === 'score'">
    <div class="row table__header">
      <div class="d-none d-md-block offset-2 col-1">Rank</div>
      <div class="d-none d-md-block col-2">Name</div>
      <div class="d-none d-md-block col-1">Score</div>
      <div class="d-none d-md-block col-1">Week</div>
      <div class="d-none d-md-block col-2">Opponent</div>
      <div class="d-none d-md-block col-1">Opp. Score</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(matchup, index) in matchups"
      :key="index"
    >
      <div class="col-1 offset-md-2">
        {{index + 1}}
      </div>
      <div class="col-6 col-md-2">
        {{ matchup.team.owner.firstName }} {{ matchup.team.owner.lastName }}
      </div>
      <div class="col-3 col-md-1 text--bold">
        {{ matchup.pointsByScoringPeriod }}
      </div>
      <div class="col-3 offset-md-0 col-md-1">
        <span class="d-none d-md-block">
          {{matchup.year}} - {{matchup.week}}
        </span>
        <span class="d-md-none text--small text--secondary">
          <div class="row">
            Week
          </div>
          <div class="row">
            {{matchup.year}} - {{matchup.week}}
          </div>
        </span>
      </div>
      <div class="col-4 col-md-2">
        <span class="d-none d-md-block">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
        <span class="d-md-none text--small text--secondary">
          <div class="row">
            Opponent
          </div>
          <div class="row">
            {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
          </div>
        </span>
      </div>
      <div class="col-2">
        <span class="d-none d-md-block">
          {{ matchup.pointsAgainstByScoringPeriod }}
        </span>
        <span class="d-md-none text--small text--secondary">
          {{ matchup.pointsAgainstByScoringPeriod }}
        </span>
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'victorymargins'">
    <div class="row table__header">
      <div class="d-none d-md-block offset-2 col-1">Rank</div>
      <div class="d-none d-md-block col-2">Name</div>
      <div class="d-none d-md-block col-1">Margin</div>
      <div class="d-none d-md-block col-1">Score</div>
      <div class="d-none d-md-block col-1">Week</div>
      <div class="d-none d-md-block col-2">Opponent</div>
      <div class="d-none d-md-block col-1">Opp. Score</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(matchup, index) in victoryMargins"
      :key="index"
    >
      <div class="col-1 offset-md-2">
        {{index + 1}}
      </div>
      <div class="col-6 col-md-2">
        {{ matchup.team.owner.firstName }} {{ matchup.team.owner.lastName }}
      </div>
      <div class="col-2 col-md-1">
        <div class="row">
          <div class="col-12 d-md-none text--secondary text--small">
            Margin
          </div>
          <div class="col-12 text--bold">
            {{ Math.round(matchup.margin * 100) / 100 }}
          </div>
        </div>
      </div>
      <div class="col-2 col-md-1">
        <div class="row">
          <div class="col-12 d-md-none text--secondary text--small">
            Score
          </div>
          <div class="col-12">
            {{ matchup.pointsByScoringPeriod }}
          </div>
        </div>
      </div>
      <div class="offset-1 col-3 offset-md-0 col-md-1">
        <span class="d-none d-md-block">
          {{matchup.year}} - {{matchup.week}}
        </span>
        <span class="d-md-none text--small text--secondary">
          <div class="row">
            Week
          </div>
          <div class="row">
            {{matchup.year}} - {{matchup.week}}
          </div>
        </span>
      </div>
      <div class="col-6 col-md-2">
        <span class="d-none d-md-block">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
        <span class="d-md-none text--small text--secondary">
          <div class="row">
            Opponent
          </div>
          <div class="row">
            {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
          </div>
        </span>
      </div>
      <div class="col-1 col-md-1">
        <span class="d-none d-md-block">
          {{ matchup.pointsAgainstByScoringPeriod }}
        </span>
        <span class="d-md-none text--secondary">
          <div class="row">
            {{ matchup.pointsAgainstByScoringPeriod }}
          </div>
        </span>
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'luckywinners'">
    <div class="row table__header">
      <div class="d-none d-md-block offset-2 col-1">Rank</div>
      <div class="d-none d-md-block col-2">Winner</div>
      <div class="d-none d-md-block col-1">Score</div>
      <div class="d-none d-md-block col-1">Week</div>
      <div class="d-none d-md-block col-2">Loser</div>
      <div class="d-none d-md-block col-1">Opp. Score</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(matchup, index) in luckyWinners"
      :key="index"
    >
      <div class="col-1 offset-2">
        {{index + 1}}
      </div>
      <div class="col-6 col-md-2">
        {{ matchup.team.owner.firstName }} {{ matchup.team.owner.lastName }}
      </div>
      <div class="col-2 col-md-1">
        {{ matchup.points }}
      </div>
      <div class="col-3 col-md-1">
        <div class="d-md-none row text--small text--secondary">
          <div class="col-12">
            Week
          </div>
          <div class="col-12">
            {{ matchup.year }} - {{matchup.week}}
          </div>
        </div>
        <div class="d-none d-md-block">
          {{matchup.year}} - {{matchup.week}}
        </div>
      </div>
      <div class="col-6 col-md-2">
        <span class="d-md-none text--secondary">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
        <span class="d-none d-md-block">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
      </div>
      <div class="col-2 col-md-1">
        <span class="d-md-none text--secondary">
          {{ matchup.pointsAgainst}}
        </span>
        <span class="d-none d-md-block">
          {{ matchup.pointsAgainst}}
        </span>
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'unluckylosers'">
    <div class="row table__header">
      <div class="d-none d-md-block offset-2 col-1">Rank</div>
      <div class="d-none d-md-block col-2">Loser</div>
      <div class="d-none d-md-block col-1">Score</div>
      <div class="d-none d-md-block col-1">Week</div>
      <div class="d-none d-md-block col-2">Winner</div>
      <div class="d-none d-md-block col-1">Opp. Score</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(matchup, index) in unluckyLosers"
      :key="index"
    >
      <div class="col-1 offset-2">
        {{index + 1}}
      </div>
      <div class="col-6 col-md-2">
        {{ matchup.team.owner.firstName }} {{ matchup.team.owner.lastName }}
      </div>
      <div class="col-2 col-md-1">
        {{ matchup.points }}
      </div>
      <div class="col-3 col-md-1">
        <div class="d-md-none row text--small text--secondary">
          <div class="col-12">
            Week
          </div>
          <div class="col-12">
            {{ matchup.year }} - {{matchup.week}}
          </div>
        </div>
        <div class="d-none d-md-block">
          {{matchup.year}} - {{matchup.week}}
        </div>
      </div>
      <div class="col-6 col-md-2">
        <span class="d-md-none text--secondary">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
        <span class="d-none d-md-block">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
      </div>
      <div class="col-2 col-md-1">
        <span class="d-md-none text--secondary">
          {{ matchup.pointsAgainst}}
        </span>
        <span class="d-none d-md-block">
          {{ matchup.pointsAgainst}}
        </span>
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'highestloser'">
    <div class="row table__header">
      <div class="d-none d-md-block offset-2 col-1">Rank</div>
      <div class="d-none d-md-block col-2">Loser</div>
      <div class="d-none d-md-block col-1">Score</div>
      <div class="d-none d-md-block col-1">Week</div>
      <div class="d-none d-md-block col-2">Winner</div>
      <div class="d-none d-md-block col-1">Opp. Score</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(matchup, index) in highestScoringLosers"
      :key="index"
    >
      <div class="col-1 offset-2">
        {{index + 1}}
      </div>
      <div class="col-6 col-md-2">
        {{ matchup.team.owner.firstName }} {{ matchup.team.owner.lastName }}
      </div>
      <div class="col-2 col-md-1">
        {{ matchup.points }}
      </div>
      <div class="col-3 col-md-1">
        <div class="d-md-none row text--small text--secondary">
          <div class="col-12">
            Week
          </div>
          <div class="col-12">
            {{ matchup.year }} - {{matchup.week}}
          </div>
        </div>
        <div class="d-none d-md-block">
          {{matchup.year}} - {{matchup.week}}
        </div>
      </div>
      <div class="col-6 col-md-2">
        <span class="d-md-none text--secondary">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
        <span class="d-none d-md-block">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
      </div>
      <div class="col-2 col-md-1">
        <span class="d-md-none text--secondary">
          {{ matchup.pointsAgainst}}
        </span>
        <span class="d-none d-md-block">
          {{ matchup.pointsAgainst}}
        </span>
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'lowestwinner'">
    <div class="row table__header">
      <div class="d-none d-md-block offset-2 col-1">Rank</div>
      <div class="d-none d-md-block col-2">Winner</div>
      <div class="d-none d-md-block col-1">Score</div>
      <div class="d-none d-md-block col-1">Week</div>
      <div class="d-none d-md-block col-2">Loser</div>
      <div class="d-none d-md-block col-1">Opp. Score</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(matchup, index) in lowestScoringWinners"
      :key="index"
    >
      <div class="col-1 offset-2">
        {{index + 1}}
      </div>
      <div class="col-6 col-md-2">
        {{ matchup.team.owner.firstName }} {{ matchup.team.owner.lastName }}
      </div>
      <div class="col-2 col-md-1">
        {{ matchup.points }}
      </div>
      <div class="col-3 col-md-1">
        <div class="d-md-none row text--small text--secondary">
          <div class="col-12">
            Week
          </div>
          <div class="col-12">
            {{ matchup.year }} - {{matchup.week}}
          </div>
        </div>
        <div class="d-none d-md-block">
          {{matchup.year}} - {{matchup.week}}
        </div>
      </div>
      <div class="col-6 col-md-2">
        <span class="d-md-none text--secondary">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
        <span class="d-none d-md-block">
          {{ matchup.opponent.owner.firstName }} {{ matchup.opponent.owner.lastName }}
        </span>
      </div>
      <div class="col-2 col-md-1">
        <span class="d-md-none text--secondary">
          {{ matchup.pointsAgainst}}
        </span>
        <span class="d-none d-md-block">
          {{ matchup.pointsAgainst}}
        </span>
      </div>
    </div>
  </div>
  <div v-else-if="boardType ==='modalscore'">
    <div class="row table__header">
      <div class="col-4 offset-md-4 col-md-1">Rank</div>
      <div class="col-4 col-md-1">Score</div>
      <div class="col-4 col-md-1">Count</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(score, index) in scores"
      :key="index"
    >
      <div class="col-4 offset-md-4 col-md-1">
        {{index+1}}
      </div>
      <div class="col-4 col-md-1">
        {{ score.points }}
      </div>
      <div class="col-4 col-md-1">
        {{ score.count }}
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'weeklyaverage'">
    <div class="row table__header">
      <div class="col-3 offset-md-4 col-md-1">Rank</div>
      <div class="col-3 col-md-1">Score</div>
      <div class="col-3 col-md-1">Week</div>
      <div class="col-3 col-md-1">Teams</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(score, index) in weeklyAverageScores"
      :key="index"
    >
      <div class="col-3 offset-md-4 col-md-1">
        {{index+1}}
      </div>
      <div class="col-3 col-md-1">
        {{ score.average }}
      </div>
      <div class="col-4 col-md-1">
        {{ score.year }} - {{ score.week }}
      </div>
      <div class="col-2 col-md-1">
        {{ score.scores.length }}
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'yearlyaverage'">
    <div class="row table__header">
      <div class="col-3 offset-md-4 col-md-1">Rank</div>
      <div class="col-3 col-md-1">Score</div>
      <div class="col-3 col-md-1">Year</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(score, index) in yearlyAverageScores"
      :key="index"
    >
      <div class="col-3 offset-md-4 col-md-1">
        {{index+1}}
      </div>
      <div class="col-3 col-md-1">
        {{ score.average }}
      </div>
      <div class="col-4 col-md-1">
        {{ score.year }}
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'weeklymargins'">
    <div class="row table__header">
      <div class="col-3 offset-md-4 col-md-1">Rank</div>
      <div class="col-3 col-md-1">Score</div>
      <div class="col-3 col-md-1">Week</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(score, index) in weeklyMargins"
      :key="index"
    >
      <div class="col-3 offset-md-4 col-md-1">
        {{index+1}}
      </div>
      <div class="col-3 col-md-1">
        {{ score.margin }}
      </div>
      <div class="col-4 col-md-1">
        {{ score.year }} - {{ score.week }}
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'medianweeks'">
    <div class="row table__header">
      <div class="col-3 offset-md-4 col-md-1">Rank</div>
      <div class="col-3 col-md-1">Score</div>
      <div class="col-3 col-md-1">Week</div>
      <div class="col-3 col-md-1">Teams</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(score, index) in weeklyMedianScores"
      :key="index"
    >
      <div class="col-3 offset-md-4 col-md-1">
        {{index+1}}
      </div>
      <div class="col-3 col-md-1">
        {{ score.median }}
      </div>
      <div class="col-4 col-md-1">
        {{ score.year }} - {{ score.week }}
      </div>
      <div class="col-2 col-md-1">
        {{ score.scores.length }}
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'medianyears'">
    <div class="row table__header">
      <div class="col-4 offset-md-4 col-md-1">Rank</div>
      <div class="col-4 col-md-1">Score</div>
      <div class="col-4 col-md-1">Year</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(score, index) in yearlyMedianScores"
      :key="index"
    >
      <div class="col-4 offset-md-4 col-md-1">
        {{index+1}}
      </div>
      <div class="col-4 col-md-1">
        {{ score.median }}
      </div>
      <div class="col-4 col-md-1">
        {{ score.year }}
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'highestlow'">
    <div class="row table__header">
      <div class="col-4 offset-md-4 col-md-1">Rank</div>
      <div class="col-4 col-md-1">Low Score</div>
      <div class="col-4 col-md-1">Week</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(score, index) in lowestWeeklyScores"
      :key="index"
    >
      <div class="col-4 offset-md-4 col-md-1">
        {{index+1}}
      </div>
      <div class="col-4 col-md-1">
        {{ score.lowest }}
      </div>
      <div class="col-4 col-md-1">
        {{ score.year }} - {{ score.week }}
      </div>
    </div>
  </div>
  <div v-else-if="boardType === 'lowesthigh'">
    <div class="row table__header">
      <div class="col-4 offset-md-4 col-md-1">Rank</div>
      <div class="col-4 col-md-1">High Score</div>
      <div class="col-4 col-md-1">Week</div>
    </div>
    <div
      class="row row--expanded"
      v-for="(score, index) in highestWeeklyScores"
      :key="index"
    >
      <div class="col-4 offset-md-4 col-md-1">
        {{index+1}}
      </div>
      <div class="col-4 col-md-1">
        {{ score.highest }}
      </div>
      <div class="col-4 col-md-1">
        {{ score.year }} - {{ score.week }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Matchup, { MatchupResult } from "@/shared/matchups/matchup";
import orderBy from "lodash/orderBy";
import Owner from "@/shared/owners/owner";
import OwnerTeam from "@/shared/teams/owner-team";
import { ref } from "vue";
import Season from "@/shared/seasons/season";
import Team from "@/shared/teams/team";
import { useStore } from 'vuex';
import { watch } from 'vue';

function consolidateSeasons(seasons: Season[]): MatchupResult[] {
  const matchups: MatchupResult[] = [];
  const ownerTeams: OwnerTeam[] = [];
  const date = new Date();
  const currentYear =
    date.getMonth() > 2 ? date.getFullYear() : date.getFullYear() - 1;
  let memberCount = 1;

  function getOwnerTeam(
    ownerTeams: OwnerTeam[],
    opponentId: number,
    season: number
  ): OwnerTeam {
    const baseOwnerTeam = {
      id: 0,
      owner: {
        id: "0",
        firstName: "BYE",
        lastName: "WEEK",
      },
    };

    if (opponentId === 0) return baseOwnerTeam;

    for (let i = 0; i < ownerTeams.length; i++) {
      const ownerTeam = ownerTeams[i];
      const teamYear = ownerTeam.teamYears && ownerTeam.teamYears.find((teamYear) => {
        return teamYear.year === season && teamYear.team === opponentId;
      });

      if (teamYear) return ownerTeam;
    }

    return baseOwnerTeam;
  }

  function getMatchupScores(
    matchup: Matchup,
    teamSide: string,
    season: Season
  ): void {
    if (!matchup[teamSide]) return;

    for (const week in matchup[teamSide].pointsByScoringPeriod) {
      let opponentSide = "home";
      if (teamSide === "home") opponentSide = "away";
      
      const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup[teamSide].teamId, season.seasonId);

      const opponent: OwnerTeam = getOwnerTeam(
        ownerTeams,
        (matchup[opponentSide] && matchup[opponentSide].teamId) || 0,
        season.seasonId
      );

      let result: string;

      if (matchup.winner === teamSide.toUpperCase()) {
        result = "W";
      } else if (matchup.winner === "TIE") {
        result = "T";
      } else if (matchup.winner === "UNDECIDED") {
        result  = "U";
      } else {
        result = "L";
      }

      if (matchup[teamSide].pointsByScoringPeriod) {
        const score: MatchupResult = {
          margin: 0,
          points: matchup[teamSide].totalPoints,
          pointsByScoringPeriod: matchup[teamSide].pointsByScoringPeriod[week],
          pointsAgainst: matchup[opponentSide] && matchup[opponentSide].totalPoints,
          pointsAgainstByScoringPeriod: matchup[opponentSide] && matchup[opponentSide].pointsByScoringPeriod && matchup[opponentSide].pointsByScoringPeriod[week],
          opponent: opponent,
          result: result,
          team: currentTeam,
          week: parseInt(week),
          year: season.seasonId,
        };

        score.margin = (score.pointsByScoringPeriod || 0) - (score.pointsAgainstByScoringPeriod || 0);

        matchups.push(score);
      }
    }
  }

  for (let i = 0; i < seasons.length; i++) {
    const season = seasons[i];
    for (let k = 0; k < season.members.length; k++) {
      const member: Owner = season.members[k];

      if (!ownerTeams.some((x) => x.owner.id === member.id)) {
        memberCount++;
        const ownerTeam: OwnerTeam = {
          id: memberCount,
          currentSeasonGames: {
            pointsFor: 0,
            pointsAgainst: 0,
            wins: 0,
            losses: 0,
            ties: 0,
            matchupCount: 0,
          },
          recentGames: {
            pointsFor: 0,
            pointsAgainst: 0,
            wins: 0,
            losses: 0,
            ties: 0,
            matchupCount: 0,
          },
          matchupHistory: [],
          owner: member,
          teams: [],
          teamYears: [],
          highScore: {
            points: 0,
          },
          lowScore: {
            points: 500,
          },
          championshipYears: [],
          playoffYears: [],
          playoffWins: 0,
          experience: 0,
        };
        ownerTeams.push(ownerTeam);
      }
    }
  }

  for (let i = 0; i < seasons.length; i++) {
    // todo this loop exists in multiple places so it may be abvle to be a service that can only run one time when the site is loaded/leagueid is switched
    const season: Season = seasons[i];

    for (let j = 0; j < season.teams.length; j++) {
      const team: Team = season.teams[j];

      for (let i = 0; i < ownerTeams.length; i++) {
        const ownerTeam: OwnerTeam = ownerTeams[i];
        if (ownerTeam.owner.id === team.owners[0] && ownerTeam.teams && ownerTeam.teamYears) {
          ownerTeam.teams.push(team);
          ownerTeam.teamYears.push({ year: season.seasonId, team: team.id });
          if (season.seasonId !== currentYear) {
            if (!ownerTeam.experience) ownerTeam.experience = 0;
            ownerTeam.experience++;
          }
        }
      }
    }

    for (
      let matchupIndex = 0;
      matchupIndex < season.schedule.length;
      matchupIndex++
    ) {
      const matchup: Matchup = season.schedule[matchupIndex];
      getMatchupScores(matchup, "away", season);
      getMatchupScores(matchup, "home", season);
    }
  }

  return orderBy(matchups, ["pointsByScoringPeriod", "year", "week"], ["desc", "asc", "asc"]);
}

function countScores(matchups:  MatchupResult[]) {
  type ScoreCounter = { [index: number]: any; points: number; count: number };
  const scores: ScoreCounter = {} as ScoreCounter;

  for (let i = 0; i < matchups.length; i++) {
    const matchup: MatchupResult = matchups[i];
    if (!scores[matchup.points]) {
      scores[matchup.points] = {
        points: matchup.points,
        count: 0,
      };
    }

    scores[matchup.points].count++;
  }

  return orderBy(scores, ["count", "points"], ["desc", "desc"]);
}

function getMedianNumber(array: number[]) {
  const mid = Math.floor(array.length / 2);
  const nums = [...array].sort((a, b) => a - b);
  return array.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
}

function getAverage(array: number[]) {
  return array.reduce((a: number, b: number) => a + b) / array.length;
}

function getWeeklyMedianScores(matchups: MatchupResult[]) {
  type ScoreCounter = {[index: string]: any; week: number; year: number; median: number };
  const scores: ScoreCounter = { } as ScoreCounter;

  for (let i = 0; i < matchups.length; i++) {
    const matchup = matchups[i];

    if (!scores[matchup.week + '-' + matchup.year]) {
      scores[matchup.week + '-' + matchup.year] = {
        week: matchup.week,
        year: matchup.year, 
        scores: [],
        median: 0,
      };
    }

    scores[matchup.week + '-' + matchup.year].scores.push(matchup.pointsByScoringPeriod);
  }

  for (const weeklyScore in scores) {
    scores[weeklyScore].median = parseFloat(getMedianNumber(scores[weeklyScore].scores).toFixed(2));
  }

  return orderBy(scores, ["median", "year", "week"], ["desc", "asc", "asc"]);
}

function getWeeklyAverageScores(matchups: MatchupResult[]) {
  type ScoreCounter = {[index: string]: any; week: number; year: number; average: number };
  const scores: ScoreCounter = { } as ScoreCounter;

  for (let i = 0; i < matchups.length; i++) {
    const matchup = matchups[i];

    if (!scores[matchup.week + '-' + matchup.year]) {
      scores[matchup.week + '-' + matchup.year] = {
        week: matchup.week,
        year: matchup.year, 
        scores: [],
        average: 0,
      };
    }

    scores[matchup.week + '-' + matchup.year].scores.push(matchup.pointsByScoringPeriod);
  }

  for (const weeklyScore in scores) {
    scores[weeklyScore].average = parseFloat(getAverage(scores[weeklyScore].scores).toFixed(2))
  }

  return orderBy(scores, ["average", "year", "week"], ["desc", "asc", "asc"]);  
}

function getYearlyAverageScores(matchups: MatchupResult[]) {
  type ScoreCounter = {[index: string]: any; year: number; average: number };
  const scores: ScoreCounter = { } as ScoreCounter;

  for (let i = 0; i < matchups.length; i++) {
    const matchup = matchups[i];

    if (!scores[matchup.year]) {
      scores[matchup.year] = {
        year: matchup.year, 
        scores: [],
        average: 0,
      };
    }

    scores[matchup.year].scores.push(matchup.pointsByScoringPeriod);
  }

  for (const yearlyScore in scores) {
    scores[yearlyScore].average = parseFloat(getAverage(scores[yearlyScore].scores).toFixed(2))
  }

  return orderBy(scores, ["average", "year"], ["desc", "asc"]);  
}

function getYearlyMedianScores(matchups: MatchupResult[]) {
  type ScoreCounter = {[index: string]: any; year: number; median: number };
  const scores: ScoreCounter = { } as ScoreCounter;

  for (let i = 0; i < matchups.length; i++) {
    const matchup = matchups[i];

    if (!scores[matchup.year]) {
      scores[matchup.year] = {
        year: matchup.year, 
        scores: [],
        median: 0,
      };
    }

    scores[matchup.year].scores.push(matchup.pointsByScoringPeriod);
  }

  for (const yearlyScore in scores) {
    scores[yearlyScore].median = parseFloat(getMedianNumber(scores[yearlyScore].scores).toFixed(2));
  }

  return orderBy(scores, ["median", "year"], ["desc", "asc"]);
}

function getLowestWeeklyScores(matchups: MatchupResult[], unordered?: boolean) {
  type ScoreCounter = {[index: string]: any; week: number; year: number; lowest: number; scores: number[] };
  const scores: ScoreCounter = { } as ScoreCounter;

  for (let i = 0; i < matchups.length; i++) {
    const matchup = matchups[i];

    if (!scores[matchup.year + '-' + matchup.week]) {
      scores[matchup.year + '-' + matchup.week] = {
        year: matchup.year, 
        week: matchup.week,
        scores: [],
        lowest: 0,
      };
    }

    scores[matchup.year + '-' + matchup.week].scores.push(matchup.pointsByScoringPeriod);
  }

  for (const weeklyScore in scores) {
    scores[weeklyScore].lowest = Math.min(...scores[weeklyScore].scores);
  }

  if (unordered) return scores;

  return orderBy(scores, ["lowest", "year", "week"], ["desc", "asc", "asc"]);
}

function getHighestWeeklyScores(matchups: MatchupResult[]) {
  type ScoreCounter = {[index: string]: any; week: number; year: number; highest: number; scores: number[] };
  const scores: ScoreCounter = { } as ScoreCounter;

  for (let i = 0; i < matchups.length; i++) {
    const matchup = matchups[i];

    if (!scores[matchup.year + '-' + matchup.week]) {
      scores[matchup.year + '-' + matchup.week] = {
        year: matchup.year, 
        week: matchup.week,
        scores: [],
        highest: 0,
      };
    }

    scores[matchup.year + '-' + matchup.week].scores.push(matchup.pointsByScoringPeriod);
  }

  for (const weeklyScore in scores) {
    scores[weeklyScore].highest = Math.max(...scores[weeklyScore].scores);
  }

  return orderBy(scores, ["highest", "year", "week"], ["asc", "asc", "asc"]);
}

function getMarginOfVictories(matchups: MatchupResult[]) {
  const victoryMargins = matchups.slice();
  const filtered = victoryMargins.filter(x =>  x.margin && x.margin >= 0 && x.points > 0 && x.pointsAgainst > 0);

  return orderBy(filtered, ["margin", "year", "week"], ["desc", "asc", "asc"]);
} 

function getWeeklyScores(matchups: MatchupResult[]): {[index: string]: any; weeklyMatchups: MatchupResult[] } {
  type ScoreCounter = {[index: string]: any; weeklyMatchups: MatchupResult[] };
  const scores: ScoreCounter = { } as ScoreCounter;

  for (let i = 0; i < matchups.length; i++) {
    const matchup = matchups[i];

    if (!scores[matchup.year + '-' + matchup.week]) {
      scores[matchup.year + '-' + matchup.week] = {
        weeklyMatchups: [],
      };
    }    
    
    scores[matchup.year + '-' + matchup.week].weeklyMatchups.push(Object.assign({}, matchup));
  }

  return scores;
}

function getWeeklyMargins(matchups: MatchupResult[]) {
  type ScoreCounter = {[index: string]: any; week: number; year: number; margin: number; scores: number[] };
  const scores: ScoreCounter = { } as ScoreCounter;
  const highScores: any = getHighestWeeklyScores(matchups);
  const lowScores: any = getLowestWeeklyScores(matchups, true);

  for (let i = 0; i < highScores.length; i++) {
    const high = highScores[i];
    const low = lowScores[high.year + '-' + high.week];

    scores[high.year + '-' + high.week] = {
      year: high.year,
      week: high.week,
      margin: parseFloat((high.highest - low.lowest).toFixed(2)),
    }
  }

  return orderBy(scores, ['margin', 'year', 'week'], ['asc', 'asc', 'asc']);
}

function getLuckyWinners(matchups: MatchupResult[]) {
  const luckyWinners = [];
  const scores = getWeeklyScores(matchups);

  for (const score in scores) {
    let min = Infinity; 
    let secondMin = Infinity; 
    let secondMinIndex = undefined;
    let minIndex = undefined;
    for (let j = 0; j < scores[score].weeklyMatchups.length; j++) {
      const weeklyMatchup = scores[score].weeklyMatchups[j];

      if (weeklyMatchup.points < min) {
        secondMinIndex = minIndex;
        secondMin = min;
        min = weeklyMatchup.points; 
        minIndex = j;
      } else if (weeklyMatchup.points < secondMin) {
        secondMin = weeklyMatchup.points; 
        secondMinIndex = j;
      }
    }

    if (secondMinIndex && scores[score].weeklyMatchups[secondMinIndex].opponent.id > 0 && scores[score].weeklyMatchups[secondMinIndex].result === "W") {
      luckyWinners.push(scores[score].weeklyMatchups[secondMinIndex]);
    }
  }

  return orderBy(luckyWinners, ["year", "week"], ["desc", "desc"]);
}

function getUnluckyLosers(matchups: MatchupResult[]) {
  const unluckyLosers = [];
  const scores = getWeeklyScores(matchups);

  for (const score in scores) {
    let max = 0; 
    let secondMax = 0; 
    let secondMaxIndex = undefined;
    let maxIndex = undefined;
    for (let j = 0; j < scores[score].weeklyMatchups.length; j++) {
      const weeklyMatchup = scores[score].weeklyMatchups[j];

      if (weeklyMatchup.points > max) {
        secondMaxIndex = maxIndex;
        secondMax = max;
        max = weeklyMatchup.points; 
        maxIndex = j;
      } else if (weeklyMatchup.points > secondMax) {
        secondMax = weeklyMatchup.points; 
        secondMaxIndex = j;
      }
    }

    if (secondMaxIndex && scores[score].weeklyMatchups[secondMaxIndex].opponent.id > 0 && scores[score].weeklyMatchups[secondMaxIndex].result === "L") {
      unluckyLosers.push(scores[score].weeklyMatchups[secondMaxIndex]);
    }
  }

  return orderBy(unluckyLosers, ["year", "week"], ["desc", "desc"]);
}

function getLowestScoringWinners(matchups: MatchupResult[]) {
  const lowestScoringWinners = matchups.slice();
  const winners = lowestScoringWinners.filter(x => x.result === "W");
  return orderBy(winners, ["pointsByScoringPeriod", "year", "week"], ["asc", "desc", "desc"]);
}

function getHighestScoringLosers(matchups: MatchupResult[]) {
  const highestScoringLosers = matchups.slice();
  const losers = highestScoringLosers.filter(x => x.opponent.id && x.result === "L" && x.opponent.id > 0);
  return orderBy(losers, ["pointsByScoringPeriod", "year", "week"], ["desc", "desc", "desc"]);
}

function useHistory() {
  const matchups = ref<MatchupResult[]>([]);
  const boardType = ref('score');
  const scores = ref({});
  const weeklyMedianScores = ref({});
  const weeklyAverageScores = ref({});
  const yearlyMedianScores = ref({});
  const yearlyAverageScores = ref({});
  const lowestWeeklyScores = ref({});
  const highestWeeklyScores = ref({});
  const victoryMargins = ref({});
  const weeklyMargins = ref({});
  const luckyWinners = ref({});
  const unluckyLosers = ref({});
  const highestScoringLosers = ref({});
  const lowestScoringWinners = ref({});
  const store = useStore();
  const selectedBoardText = { 
    'score': 'Highest Scores',
    'modalscore': 'Modal Scores',
    'medianweeks': 'Weekly Median',
    'weeklyaverage': 'Weekly Average',
    'medianyears': 'Yearly Median',
    'yearlyaverage': 'Yearly Average',
    'highestlow': 'Highest Low Score',
    'lowesthigh': 'Lowest High Score',
    'victorymargins': 'Victory Margins',
    'weeklymargins': 'Weekly Margins',
    'luckywinners': 'Lucky Winners',
    'unluckylosers': 'Unlucky Losers',
    'highestloser': 'Highest Losers',
    'lowestwinner': 'Lowest Winner',
  }

  async function getLeagueHistory() {
    matchups.value = [];
    scores.value = {};
    weeklyMedianScores.value = {};
    weeklyAverageScores.value = {};
    yearlyMedianScores.value = {};
    yearlyAverageScores.value = {};
    lowestWeeklyScores.value = {};
    highestWeeklyScores.value = {};
    victoryMargins.value = {};
    weeklyMargins.value = {};
    luckyWinners.value = {};
    unluckyLosers.value = {};
    lowestScoringWinners.value = {};
    highestScoringLosers.value = {};

    matchups.value = consolidateSeasons(store.state.league) as MatchupResult[];

    scores.value = countScores(matchups.value);
    weeklyMedianScores.value = getWeeklyMedianScores(matchups.value);
    weeklyAverageScores.value = getWeeklyAverageScores(matchups.value);
    yearlyMedianScores.value = getYearlyMedianScores(matchups.value);
    yearlyAverageScores.value = getYearlyAverageScores(matchups.value);
    lowestWeeklyScores.value = getLowestWeeklyScores(matchups.value);
    highestWeeklyScores.value = getHighestWeeklyScores(matchups.value);
    victoryMargins.value = getMarginOfVictories(matchups.value);
    weeklyMargins.value = getWeeklyMargins(matchups.value);
    luckyWinners.value = getLuckyWinners(matchups.value);
    unluckyLosers.value = getUnluckyLosers(matchups.value);
    lowestScoringWinners.value = getLowestScoringWinners(matchups.value);
    highestScoringLosers.value = getHighestScoringLosers(matchups.value);
  }

  watch(
    () => store.state.leagueId,
    () => {
      getLeagueHistory();
    }
  )

  watch(
    () => store.state.league,
    () => {
      getLeagueHistory();
    }
  )

  getLeagueHistory();

  return { 
    boardType, 
    matchups, 
    scores, 
    selectedBoardText,
    weeklyMedianScores, 
    yearlyMedianScores,
    weeklyAverageScores,
    yearlyAverageScores,
    lowestWeeklyScores,
    highestWeeklyScores,
    victoryMargins,
    weeklyMargins,
    luckyWinners,
    unluckyLosers,
    highestScoringLosers,
    lowestScoringWinners,
  };
}

export default {
  setup() {
    return useHistory();
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";
.toggle--leaderboard {
  position: absolute; 
  top: -45px; 
  right:0;
}

.toggle--leaderboard.collapsed > .fa-caret-down {
  transform: rotate(0deg);
  transition: 0.35s;
}

.toggle--leaderboard > .fa-caret-down {
  transform: rotate(180deg);
  transition: 0.35s;
}

.navbar--leaderboard {
  margin-left: 50%;
}

@media screen and (min-width: $width-large) {
  .navbar--leaderboard {
    margin-left: initial;
  }
}
</style>